import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

export default class LoaderOverlay extends PureComponent {
  static propTypes = {
    show: PropTypes.bool,
  };

  static defaultProps = {
    show: false,
  };

  render = () => (
    <div
      style={{
        position: 'absolute',
        display: this.props.show ? 'block' : 'none',
        top: '0',
        left: '0',
        right: '0',
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.3)',
        zIndex: 3,
      }}
    >
      <i
        style={{
          position: 'relative',
          float: 'left',
          top: '50%',
          left: '50%',
          transform: 'translate(-50%, -50%)',
        }}
        className="fa fa-spinner fa-2x fa-spin"
      />
    </div>
  );
}



// WEBPACK FOOTER //
// src/modules/common/components/LoaderOverlay.js